import { loadStripe } from "@stripe/stripe-js";

// Stripe.js, loaded once and only when a billing screen first asks for it. A
// Stripe object built on every render is one the <Elements> around it has to be
// rebuilt for too, and one loaded at startup is a script every page pays for.

let stripePromise;

/** The app's Stripe instance (a promise, as <Elements> takes it). */
export const getStripe = () => {
   stripePromise = stripePromise ?? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLEKEY);
   return stripePromise;
};

/**
 * How the Payment Element is dressed. Stripe draws it inside its own iframe, so
 * nothing in the app's stylesheets reaches it: the look is handed over here, in
 * the app's font, colour and radius.
 */
export const PAYMENT_ELEMENTS_OPTIONS = Object.freeze({
   fonts: [{ cssSrc: "https://fonts.googleapis.com/css?family=Poppins:400,500,600" }],
   appearance: {
      theme: "stripe",
      variables: {
         colorPrimary: "#5770cb",
         colorText: "#000000",
         colorDanger: "#ff4d4f",
         fontFamily: "Poppins, -apple-system, BlinkMacSystemFont, sans-serif",
         borderRadius: "6px"
      }
   }
});
